import styles from './notfound.module.scss';

export default function NotFound(props) {
    const { code, text, cleanUrlParams } = props;

    return (
        <div className={styles.pre_notfound}>
            <div className={styles.notfound} data-testid={`error-${code}`}>
                <div>
                    <p className={styles.codi}>{code}</p>
                    <h3 className={styles.titol}>{text}</h3>
                </div>
            </div>
        </div>
    );
}

NotFound.defaultProps = {
    text: '',
    cleanUrlParams: false
};
